import React from 'react';
import styles from './Benefit.module.scss';

const Benefit = ({ title, description, icon }) => (
  <div className={styles.root}>
    <div className={styles.iconHolder}>
      <img src={icon} alt={title} />
    </div>
    <div className={styles.title}>{title}</div>
    <div className={styles.description}>{description}</div>
  </div>
);

export default Benefit;
